const adminUsersEmail = [
  "cyowwwoyakitawwwotz@gmail.com",
  "8hototogisu1sherlockholmes@gmail.com",
  "inatatos730@gmail.com",
  "magichello.823@gmail.com",
  "g2010201@edu.cc.ocha.ac.jp",
  "dosho-sakiko685@g.ecc.u-tokyo.ac.jp"
]
export default Object.freeze({
  adminUsersEmail: adminUsersEmail
});
